var map = {
	"./abyss-jewel-active.png": 53,
	"./abyss-jewel.png": 54,
	"./all-active.png": 55,
	"./all.png": 56,
	"./amulet-active.png": 57,
	"./amulet.png": 58,
	"./belt-active.png": 59,
	"./belt.png": 60,
	"./boots-active.png": 61,
	"./boots.png": 62,
	"./chest-active.png": 63,
	"./chest.png": 64,
	"./flask-active.png": 65,
	"./flask.png": 66,
	"./gloves-active.png": 67,
	"./gloves.png": 68,
	"./helmet-active.png": 69,
	"./helmet.png": 70,
	"./jewel-active.png": 71,
	"./jewel.png": 72,
	"./one-hand-active.png": 73,
	"./one-hand-ranged-active.png": 74,
	"./one-hand-ranged.png": 75,
	"./one-hand.png": 76,
	"./quiver-active.png": 77,
	"./quiver.png": 78,
	"./ring-active.png": 79,
	"./ring.png": 80,
	"./shield-active.png": 81,
	"./shield.png": 82,
	"./socket-blue-active.png": 83,
	"./socket-blue.png": 84,
	"./socket-green-active.png": 85,
	"./socket-green.png": 86,
	"./socket-red-active.png": 87,
	"./socket-red.png": 88,
	"./two-hand-active.png": 89,
	"./two-hand-ranged-active.png": 90,
	"./two-hand-ranged.png": 91,
	"./two-hand.png": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;